import { connect } from 'react-redux';

import { getUserName } from 'app/modules';
import PreIdentifiedUserWelcomeMessage from '../PreIdentifiedUserWelcomeMessage';

export const mapStateToProps = state => {
  return {
    name: getUserName(state),
  };
};

const PreIdentifiedUserWelcomeMessageContainer = connect(mapStateToProps)(PreIdentifiedUserWelcomeMessage);

export default PreIdentifiedUserWelcomeMessageContainer;
